<template>
    <numbering-check-settings
        model-name="proformainvoice"
        document-label="le fatture proforma"
    />
</template>

<script>
import NumberingCheckSettings from '@/components/common/NumberingCheckSettings'

export default {
    name: 'proformainvoices-other',
    components: {
        NumberingCheckSettings
    }
}
</script>
